import React from "react";
import { twMerge } from "tailwind-merge";
import cc from "classcat";
import PropTypes from "prop-types";
import { formatDistanceToNowStrict } from "date-fns";
import { fromZonedTime } from "date-fns-tz";
import useDateFnsLocale from "../intl/useDateFnsLocale";
import Trans from "../intl/Trans";
import DropdownItem from "../uikit/Dropdown/DropdownItem";
NavbarNotification.propTypes = {
    icon: PropTypes.node.isRequired,
    message: PropTypes.node.isRequired,
    className: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
    onSelect: PropTypes.func
};
export default function NavbarNotification(param) {
    var icon = param.icon, message = param.message, createdAt = param.createdAt, className = param.className, onSelect = param.onSelect;
    var dateFnsLocale = useDateFnsLocale();
    var timeAgo = formatDistanceToNowStrict(fromZonedTime(createdAt, "UTC"), {
        locale: dateFnsLocale
    });
    return /*#__PURE__*/ React.createElement(DropdownItem, {
        onSelect: onSelect,
        className: twMerge(cc([
            "flex items-center gap-3 px-4"
        ], className))
    }, icon, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col text-sm"
    }, message, /*#__PURE__*/ React.createElement("div", {
        className: "text-xs text-gray-400"
    }, /*#__PURE__*/ React.createElement(Trans, null, "notification.time-ago-", {
        timeAgo: timeAgo
    }))));
}
